import { FilterValue } from "@/components/Table/Filters";

const STORAGE_PREFIX = "slike_filters:";

export const getFilterStorageKey = (
  pathname: string = window.location.pathname,
  _search: string = window.location.search
): string => {
  const mainSection = pathname.split("/").filter(Boolean)[0] ?? "";
  return `${STORAGE_PREFIX}${mainSection}`;
};

export const readStoredFilters = (
  key: string = getFilterStorageKey()
): Record<string, FilterValue> => {
  try {
    const raw = localStorage.getItem(key);
    if (!raw) return {};
    const parsed = JSON.parse(raw);
    if (parsed && typeof parsed === "object" && !Array.isArray(parsed)) {
      return parsed as Record<string, FilterValue>;
    }
    return {};
  } catch {
    return {};
  }
};

export const writeStoredFilters = (
  filters: Record<string, FilterValue>,
  key: string = getFilterStorageKey()
): void => {
  try {
    const cleaned = cleanFilters(filters);
    if (Object.keys(cleaned).length === 0) {
      localStorage.removeItem(key);
      return;
    }
    localStorage.setItem(key, JSON.stringify(cleaned));
  } catch {}
};

export const clearStoredFilters = (
  key: string = getFilterStorageKey()
): void => {
  try {
    localStorage.removeItem(key);
  } catch {
    // ignore
  }
};

const cleanFilters = (
  filters: Record<string, FilterValue>
): Record<string, FilterValue> => {
  const result: Record<string, FilterValue> = {};
  Object.entries(filters ?? {}).forEach(([key, value]) => {
    if (value === undefined || value === null) return;
    if (Array.isArray(value) && value.length === 0) return;
    result[key] = value;
  });
  return result;
};
